module.exports = __webpack_public_path__ + "static/media/pranshu.e31225f6.jpeg";